import Popover from '@material-ui/core/Popover';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import { ReactComponent as Duplicate } from 'assets/icons/duplicate2.svg';
import DeleteSvgComponent from 'assets/icons/svg/DeleteSvg/Delete';
import EditSvgComponent from 'assets/icons/svg/Edit/index';
import SearchComp from 'components/Searchcomponent';
import { useSearch } from "hook";
import React, { useEffect, useState } from 'react';
import FormPreview from './FormPreview';
import './FormTemplates.scss';

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  '.MuiFormControlLabel-label': checked && {
    color: theme.palette.primary.main,
    fontWeight: '600',
  },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = +radioGroup.value === +props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

const FormTemplates = ({
  formik,
  updateTemplateHandler,
  deleteTemplateConfirmHandler,
  setSelectedTemplate,
  formTemplates,
  formNames,
  getForms,
  searchValue,
  setSearchValue,
  onDuplicateTemplate,
  loading }) => {
  const [expandedIndex, setExpandedIndex] = useState(-1);
  const { searchAction } = useSearch({ action: setSearchValue });
  const [anchorEl, setAnchorEl] = React.useState(null);


  useEffect(() => {
    getForms();
  }, [searchValue]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    const regex = /[\*\(\)\+]/;
    if (!regex.test(inputValue)) {
      searchAction(inputValue);
    }
  };


  const handleSelectedTemplateOptions = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedTemplate(formNames[index] || null)
  }
  const handleCloseTemplateOptions = () => {
    setAnchorEl(null);
  }

  const classForm = formNames.findIndex(item => item?.id === formik?.values?.formId)
  return (
    <div className="class__form__templates">
      <div className="mb-5">
        <SearchComp
          // value={searchValue}
          setSearchText={handleInputChange}
          placeholder="Search"
          style={{ width: "100", backgroundColor: "#fff" }}
        />
      </div>
      {loading ? (
        <div className="text-center mt-10">
          <CircularProgress />
        </div>
      ) :
        formTemplates?.length > 0 ? (
          <FormControl className="w-100">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={(event) => {
                const formIndex = parseInt(event.target.value);
                formik.setFieldValue('formId', formNames[formIndex]?.id);
              }}
              defaultValue={classForm}
              value={classForm}
            >
              {formTemplates
                ?.map((item, index) => {
                  const isExpanded = index === expandedIndex;
                  return (
                    <div key={index}>
                      <FormPreview
                        formNames={formNames}
                        formik={formik}
                        item={item}
                        index={index}
                        isExpanded={isExpanded}
                        handleExpand={() => {
                          setExpandedIndex(isExpanded ? -1 : index);
                        }}
                        summary={
                          <MyFormControlLabel
                            value={index}
                            control={<Radio className="mr-3" />}
                            label={formNames?.[index]?.form_name}
                          />
                        }
                        handleSelectedTemplateOptions={handleSelectedTemplateOptions}
                      />
                    </div>
                  );
                })}
            </RadioGroup>
          </FormControl>
        ) : (
          <div className="text-center">
            <h3>No Form Templates Available</h3>
          </div>
        )}
      <Popover
        id={Boolean(anchorEl) ? 'simple-popover' : undefined}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleCloseTemplateOptions}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className="template-options__list action-pop-over">
          <div className="template-options__list-item edit-pop-over"
            onClick={() => {
              onDuplicateTemplate()
              setAnchorEl(null)
            }}
          >
            <Duplicate />
            Duplicate
          </div>
          <div className="template-options__list-item edit-pop-over" onClick={() => {
            updateTemplateHandler()
            setAnchorEl(null)
          }}>
            <EditSvgComponent />
            Edit
          </div>
          <div className="template-options__list-item delete-pop-over" onClick={() => {
            deleteTemplateConfirmHandler()
            handleCloseTemplateOptions()
          }}>
            <DeleteSvgComponent />
            Delete
          </div>
        </div>
      </Popover>

    </div>
  );
};

export default FormTemplates;
